import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

const LINKS = [
  ["/about", "About", "footer-about"],
  ["/contact", "Contact", "footer-contact"],
  ["/risk-disclosure", "Risk disclosure", "footer-risk"],
  ["/privacy", "Privacy policy", "footer-privacy"],
  ["/terms", "Terms of service", "footer-terms"],
  ["/refund-policy", "Refund policy", "footer-refund"],
  ["/login", "Trader login", "footer-login"],
];

export const SiteFooter = () => (
  <footer className="border-t border-zinc-900 py-10" data-testid="site-footer">
    <div className="px-5 sm:px-8 lg:px-12 max-w-[1240px] mx-auto">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex items-center gap-2">
          <Logo size={22} />
          <span className="font-mono text-[11px] text-zinc-600">strictrr.com</span>
        </div>
        <div className="flex-1" />
        <nav className="flex flex-wrap gap-x-5 gap-y-2">
          {LINKS.map(([to, label, tid]) => (
            <Link
              key={to}
              to={to}
              data-testid={tid}
              className="font-mono text-[11px] text-zinc-500 hover:text-zinc-200 transition-colors duration-200"
            >
              {label}
            </Link>
          ))}
        </nav>
      </div>

      <div
        className="mt-8 border-t border-zinc-900 pt-6 space-y-2 text-[11px] leading-relaxed text-zinc-600"
        data-testid="footer-disclaimer"
      >
        <p>
          Strict RR is trade-execution and risk-management software. It is not a broker, not a fund,
          not a portfolio manager and not a financial adviser. We do not provide trading signals,
          tips, buy/sell calls, investment advice or account management, and we never take custody of
          your money.
        </p>
        <p>
          Nothing on this site is a promise, projection or guarantee of profit, income or returns.
          Participating in global financial markets carries a high level of risk and you can lose some or all of
          your capital. Past performance is not indicative of future results. You are solely
          responsible for every decision you make on your own account. Use the
          software only if you fully understand these risks.
        </p>
        <p>
          Strict RR is not affiliated with, endorsed by or sponsored by Meta Platforms, Inc.,
          MetaQuotes Ltd. or any execution provider. MetaTrader 5 is a trademark of MetaQuotes Ltd.
        </p>
        <p className="text-zinc-700">
          © {new Date().getFullYear()} Strict RR · Bangalore, Karnataka, India · All rights
          reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default SiteFooter;
